import { render, staticRenderFns } from "./MyPushuDetail.vue?vue&type=template&id=2f013c3c&scoped=true&"
import script from "./MyPushuDetail.vue?vue&type=script&lang=js&"
export * from "./MyPushuDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyPushuDetail.vue?vue&type=style&index=0&id=2f013c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f013c3c",
  null
  
)

export default component.exports